import {Route, Routes} from "react-router";
import React from "react";
import ListGroup from "./list";
import CreateGroup from "./create";
import EditGroup from "./edit";
import ReviseGroupPage from "./revise";

export default function() {
  return (
    <Routes>
      <Route path={'/'} exact={true} element={<ListGroup/>} />
      <Route path={'/create'} element={<CreateGroup/>} />
      <Route path={"/edit/:id"} element={<EditGroup/>} />
      <Route path={'/revise'} element={<ReviseGroupPage/>} />
    </Routes>
  );
}
